import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const PdfGlyph = /*#__PURE__*/createElement("g", {
  id: "pdf",
  strokeWidth: "0.6px"
}, /*#__PURE__*/createElement("path", {
  d: "M63.2,27.2c0-0.4-0.2-0.8-0.5-1.1L51.2,15.4c-0.3-0.3-0.6-0.4-1-0.4v0H23.6c-3.1,0-5.5,2.5-5.5,5.5v42.9 c0,3.1,2.5,5.5,5.5,5.5h34c3.1,0,5.5-2.5,5.5-5.5L63.2,27.2L63.2,27.2z M51.6,19.9l6.2,5.8h-3.7c-1.4,0-2.5-1.1-2.5-2.5V19.9z M57.6,66h-34c-1.4,0-2.5-1.1-2.5-2.5V20.5c0-1.4,1.1-2.5,2.5-2.5h25v5.2c0,3.1,2.5,5.5,5.5,5.5h6v34.7C60.2,64.9,59,66,57.6,66z"
}), /*#__PURE__*/createElement("path", {
  d: "M48.2,45.2h6.6v2h-4.1v2.5h3.9v2h-3.9V56h-2.4V45.2z"
}), /*#__PURE__*/createElement("path", {
  d: "M36.9,45.4c0.9-0.2,2.1-0.2,3.3-0.2c2.1,0,3.4,0.4,4.4,1.2c1.1,0.8,1.8,2.1,1.8,4.1c0,2.1-0.8,3.5-1.8,4.4 c-1.1,0.9-2.9,1.4-5,1.4c-1.3,0-2.2-0.1-2.8-0.2V45.4z M39.4,54.2c0.2,0,0.6,0,0.8,0c2.2,0,3.7-1.2,3.7-3.8c0-2.2-1.3-3.4-3.4-3.4 c-0.5,0-0.9,0-1.1,0.1V54.2z"
}), /*#__PURE__*/createElement("path", {
  d: "M27.5,45.4c0.8-0.1,1.8-0.2,3.3-0.2c1.5,0,2.6,0.3,3.3,0.9c0.7,0.5,1.2,1.4,1.2,2.5c0,1.1-0.3,2-1,2.6 c-0.8,0.8-2.1,1.1-3.5,1.1c-0.3,0-0.6,0-0.8-0.1V56h-2.4V45.4z M29.9,50.3c0.2,0,0.4,0.1,0.8,0.1c1.3,0,2.1-0.7,2.1-1.7 c0-1-0.7-1.6-1.9-1.6c-0.5,0-0.8,0-1,0.1V50.3z"
}));
const Pdf = createSvg({
  name: 'pdf',
  path: PdfGlyph
});

export default Pdf;
export { PdfGlyph };
